import { render, staticRenderFns } from "./Race.vue?vue&type=template&id=f812d514&scoped=true"
var script = {}
import style0 from "./Race.vue?vue&type=style&index=0&id=f812d514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f812d514",
  null
  
)

export default component.exports